import { BIZ_TOKEN, BIZ_USERINFO } from '@/common/constant'

/**
 * 商城 PC：是否已具备「会员接口」所需登录态（Vuex 中 token + userInfo.id）。
 * 仅存在本地废 token 而无 userInfo 时视为未登录，避免误调 load_member 等接口。
 */
export function isShopLoggedIn(vm) {
  if (!vm || !vm.$store) return false
  const u = vm.$store.getters.userInfo
  return !!(vm.$store.getters.isLogin && u && u.id)
}

/**
 * 清除商城 PC 登录态（localStorage + sessionStorage + Vuex headers）。
 * 登录页写入 localStorage，退出须两处一并清理，否则首页仍带无效 token 导致 401。
 */
export function clearShopAuthStorage(store) {
  localStorage.removeItem(BIZ_TOKEN)
  localStorage.removeItem(BIZ_USERINFO)
  sessionStorage.removeItem(BIZ_TOKEN)
  sessionStorage.removeItem(BIZ_USERINFO)
  if (store) {
    store.commit('SETTOKEN', '')
    store.commit('SETUSERINFO', {})
    store.commit('SETHANDERS', { authorization: '', username: '', userId: '' })
  }
}

/**
 * 登录成功后导航：优先 ?redirect=，其次进入登录前页面，最后回首页。
 * 不使用 router.go(-1)：历史栈为空或上一页仍是 /login 时会留在登录页。
 */
export function navigateAfterLogin(vm) {
  if (vm.$store && vm.$store.dispatch) {
    vm.$store.dispatch('loadCurrencies').catch(() => {})
  }
  const raw = vm.$route && vm.$route.query && vm.$route.query.redirect
  if (raw && typeof raw === 'string' && raw.startsWith('/') && !raw.startsWith('//')) {
    vm.$router.replace(raw)
    return
  }
  const pre = sessionStorage.getItem('pre_login_path')
  if (pre && pre !== '/login' && pre !== '/register' && !pre.startsWith('/login?')) {
    sessionStorage.removeItem('pre_login_path')
    vm.$router.replace(pre)
    return
  }
  if (sessionStorage.getItem('path') === '/register') {
    sessionStorage.setItem('path', '1')
    vm.$router.replace('/')
    return
  }
  vm.$router.replace('/index')
}
